const Form = {
  name: undefined,
  businessPhase: undefined,
  hasConstitutedCompany: undefined,
  companyType: undefined,
  companyName: undefined,
  email: undefined,
  jobTitle: undefined,
  phoneNumber: undefined,
  headquartersState: undefined,
  sector: undefined,
  seekingInvestment: undefined,
  considerMA: undefined,
  consideringMA: undefined,
  hasMultiplePartners: undefined,
  hasOrganizedCaptable: undefined,
  hasShareholderAgreement: undefined,
  promisedEquity: undefined,
  receivedInvestment: undefined,
  registeredTrademark: undefined,
  employeeContractType: undefined,
  numberOfEmployees: undefined,
  formalizeContracts: undefined,
  lgpdCompliance: undefined,
  regulatedMarket: undefined,
  litigationStatus: undefined,
  points: undefined
}

export default Form



// WEBPACK FOOTER //
// ./src/models/Form.js